import { Box, Grid, MenuItem, Select, Stack } from "@mui/material";
import Header from "../../../components/Header";
import System from "./components/System";
import IntelligenceTimeFilter from "../../../components/IntelligenceTimeFilter";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import API from "../../../api";

const AgentAnalyses = () => {
  const [timeFilter, setTimeFilter] = useState({dateFrom: dayjs().subtract(3, "day"), dateTo: dayjs()});
  const [events, setEvents] = useState([]);
  const [ransomware, setRansomware] = useState([]);
  const [, setScan] = useState([]);
  const [, setIoc] = useState([]);
  const [, setNetwork] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [selectedLicense, setSelectedLicense] = useState("");
  const abortCtrl = new AbortController();
  const { signal } = abortCtrl;

  useEffect(() => {
    API.getAllLicenses({}).then((res) => {
      setLicenses(res.data);
      setSelectedLicense(res.data[0]);
    }).catch((err) => {
      setLicenses([]);
      setSelectedLicense("");
    })
  }, [])

  useEffect(() => {
    if(selectedLicense === "") return;
    API.getAgentData({licenseCode: selectedLicense, timestamp: {dateFrom: timeFilter.dateFrom.toISOString(), dateTo: timeFilter.dateTo.toISOString()}}, signal).then((res) => {
      setEvents(res.data.events);
      setRansomware(res.data.ransomware);
      setScan(res.data.scan);
      setIoc(res.data.ioc);
      setNetwork(res.data.network);
    }).catch((err) => {
      setEvents([]);
      setRansomware([]);
      setScan([]);
      setIoc([]);
      setNetwork([]);
    });
    // `signal` comes from a new AbortController created on every render (not memoized);
    // adding it here would make this effect re-run on every render instead of only when
    // the filter/license change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeFilter, selectedLicense]);

  return (
    <Box m={"20px"}>
      <Header title={"Analyses"} />
      <Stack direction={"row"} spacing={2} justifyContent={"space-between"}> 
        <IntelligenceTimeFilter
          initialDateFrom={timeFilter.dateFrom}
          initialDateTo={timeFilter.dateTo}
          onDateChange={(payload) => setTimeFilter(payload)}
          maxTimeRange={{value: 7, type: "day"}}
        />

        <Select
          value={selectedLicense}
          onChange={(e) => setSelectedLicense(e.target.value)}
          sx={{ width: "20vw", height: "auto" }}
        >
            {licenses.map((license) => (
              <MenuItem key={license} value={license}>{license}</MenuItem>
            ))}
        </Select>
      </Stack>
      <Grid container spacing={2}>
        <Grid size={6}>
          <System
            events={events}
            setEvents={setEvents}
            ransomware={ransomware}
            setRansomware={setRansomware}
          />
        </Grid>
        <Grid size={6}>

        </Grid>
      </Grid>
    </Box>
  )
};

export default AgentAnalyses;